module.exports = __webpack_public_path__ + "static/media/bv.6e2a7386.svg";